import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropdown", "suggestion"]
  static values = { url: String }
  
  connect() {
    this.inputTarget.addEventListener("focus", this.fetchSuggestions.bind(this))
    this.inputTarget.addEventListener("input", this.debounce(this.fetchSuggestions.bind(this), 300))
    this.hideDropdown()
    
    // Hide dropdown when clicking outside
    document.addEventListener("click", (e) => {
      if (!this.element.contains(e.target)) {
        this.hideDropdown()
      }
    })
  }
  
  async fetchSuggestions() {
    const query = this.inputTarget.value
    const url = `${this.urlValue}?q=${encodeURIComponent(query)}`
    
    try {
      const response = await fetch(url, {
        headers: { "Accept": "application/json" }
      })
      const data = await response.json()
      this.displaySuggestions(data.systems || [])
    } catch (error) {
      console.error("Failed to fetch systems:", error)
      this.hideDropdown()
    }
  }
  
  displaySuggestions(systems) {
    if (systems.length === 0) {
      this.hideDropdown()
      return
    }
    
    this.dropdownTarget.innerHTML = systems.map(system => 
      `<div class="px-4 py-2 hover:bg-gray-100 cursor-pointer" data-action="click->system-autocomplete#selectSystem">${this.escapeHtml(system)}</div>`
    ).join("")
    this.showDropdown()
  }
  
  selectSystem(event) {
    const systemName = event.target.textContent.trim()
    this.inputTarget.value = systemName
    this.hideDropdown()
    
    // Trigger input event for any validation or other handlers
    this.inputTarget.dispatchEvent(new Event('input'))
  }
  
  showDropdown() {
    this.dropdownTarget.classList.remove("hidden")
  }
  
  hideDropdown() {
    this.dropdownTarget.classList.add("hidden")
  }
  
  debounce(func, wait) {
    let timeout
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout)
        func(...args)
      }
      clearTimeout(timeout)
      timeout = setTimeout(later, wait)
    }
  }
  
  escapeHtml(text) {
    const div = document.createElement('div')
    div.textContent = text
    return div.innerHTML
  }
}

